import { render, staticRenderFns } from "./PreVoucherDetail.vue?vue&type=template&id=2d2e5d47&scoped=true"
import script from "./PreVoucherDetail.vue?vue&type=script&lang=js"
export * from "./PreVoucherDetail.vue?vue&type=script&lang=js"
import style0 from "./PreVoucherDetail.vue?vue&type=style&index=0&id=2d2e5d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e5d47",
  null
  
)

export default component.exports